module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-popularScience.6e42c72d2b519374f8890658fe6017c8.png";